import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  private initialized = false;

  public async init() {
    if (!environment.datadog_clientToken) {
      return;
    }

    datadogRum.init({
      applicationId: environment.datadog_applicationId,
      clientToken: environment.datadog_clientToken,
      site: environment.datadog_site,
      service: environment.datadog_service,
      env: environment.production ? 'production' : 'dev',
      // Specify a version number to identify the deployed version of your application in Datadog
      version: environment.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      actionNameAttribute: 'dd-action',
      allowedTracingUrls: [{ match: environment.serviceBaseUrl, propagatorTypes: ['tracecontext'] }],
    });

    this.initialized = true;
  }

  public async enrichWithUser(userGuid: string | null = null, roles: string | null = null) {
    datadogRum.setUser({
      id: userGuid?.toString(),
      roles: roles,
    });
  }

  public error(message: string, context?: { [x: string]: any }): void {
    if (this.initialized) {
      datadogRum.addError(message, context);
    }
  }
}
